import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import {srcUrl} from "@/api/ImageApi.ts";

export default function CampaignOverviewView() {
    const {campaign} = useCampaign();

    return <main className="grow overflow-auto p-6 md:p-10">
        <title>{campaign.title} | DireDawn</title>
        <div className="mx-auto max-w-4xl space-y-6">
            <div><p className="mb-2 text-xs font-semibold uppercase tracking-[0.22em] text-primary">Aktive Kampagne</p><h1 className="text-3xl font-semibold tracking-tight">{campaign.title}</h1></div>
            <img src={srcUrl(campaign.image)} alt={campaign.title} className="max-h-96 rounded-xl border border-border bg-card object-contain shadow-xl shadow-black/20"/>
            <p className="whitespace-pre-wrap leading-7 text-foreground/85">{campaign.description || "Keine Beschreibung vorhanden."}</p>
        </div>
    </main>;
}
